export default __webpack_public_path__ + "static/media/sd-pratyaksha-seva.1e5af49c.png";